import React from "react";
import AuthForm from "./components/AuthForm";

function VerifyOtp() {
  return <AuthForm isVerifyOtp={true} />;
}

export default VerifyOtp;
